<div class="background-overlay"></div>
<div class="fullscreen-panel new-collection-wrapper ">
  <h2 class="collection-label" (click)="selectInput()">Give your collection a name.</h2>
  <div class="collection-input-wrapper" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
    <input #inputTitle [(ngModel)]="userDataService.newCollectionName" fxFlex="1 1 100" class="collection-input" [ngClass]="{'enterAnimationDone': isEnterAnimationDone}" placeholder="{{userDataService.getNewCollectionDefaultName()}}" type="search" #searchInput />
  </div>
</div>
